export default __webpack_public_path__ + "static/media/logo-blue.15adc4fa.svg";